import { render, staticRenderFns } from "./LevelFilter.vue?vue&type=template&id=aa20a67c&"
import script from "./LevelFilter.ts?vue&type=script&lang=ts&"
export * from "./LevelFilter.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports